import { storeData } from './data/storeData';
import ProductInventory from './components/productInventory';

const { useEffect, useState } = wp.element;
const { PanelBody, TextControl, SelectControl } = wp.components;
const { InspectorControls, useBlockProps, BlockControls, AlignmentToolbar } = wp.blockEditor;

/**
 * Edit function for the Product - Lookup Table Block.
 *
 * Renders the block's edit view, providing UI controls for customisation.
 *
 * @param { Object }   props               Component properties passed from the editor.
 * @param { Object }   props.attributes    Block attributes.
 * @param { Function } props.setAttributes Function to update block attributes.
 *
 * @return { WPElement } Element to render.
 */
const Edit = ( { attributes, setAttributes } ) => {
	const { align, productsPerPage, country } = attributes;
	const blockProps = useBlockProps();
	const [ isLoading, setIsLoading ] = useState( true );
	const [ isError, setIsError ] = useState( false );

	useEffect( () => {
		storeData( attributes.country ).then( () => {
			setIsLoading( false );
		} ).catch( () => {
			setIsLoading( false );
			setIsError( true );
		} );
	}, [ attributes.country ] );

	if ( isLoading ) {
		return window.wp.i18n.__( 'Loading…', 'ac-product-lookup' );
	} else if ( isError ) {
		return window.wp.i18n.__( 'Something went wrong. Please try again later.', 'ac-product-lookup' );
	}

	return (
		<>
			<InspectorControls>
				<PanelBody title="Settings">
					<TextControl
						label="Products per page"
						value={ productsPerPage }
						onChange={ value => setAttributes( { productsPerPage: parseInt( value, 10 ) } ) }
						type="number"
					/>
					<SelectControl
						label="Country"
						value={ country }
						options={ AcProductLookupBlock.countries.map( countryOption => ( { label: countryOption[ Object.keys( countryOption )[ 0 ] ], value: Object.keys( countryOption )[ 0 ] } ) ) }
						onChange={ value => {
							setAttributes( { country: value } );
							setIsLoading( true );
							storeData( value ).then( () => {
								setIsLoading( false );
							} );
						} }
					/>
				</PanelBody>
			</InspectorControls>
			<BlockControls>
				<AlignmentToolbar
					value={ align }
					onChange={ newAlign => setAttributes( { align: newAlign } ) }
				/>
			</BlockControls>
			<div { ...blockProps }>
				<ProductInventory itemsPerPage={ attributes.productsPerPage } countryCode={ attributes.country } />
			</div>
		</>
	);
};

export default Edit;
